<template>
  <q-btn
    flat
    icon="mdi-arrow-left"
    @click="$router.back()"
  />
</template>

<script>
export default {
  name: 'UiBackButton',
};
</script>
